import { createStore, applyMiddleware } from 'redux';
import { responsiveStoreEnhancer, calculateResponsiveState } from 'redux-responsive';
import thunk from 'redux-thunk';
import rootReducer, { sessionOnlyReducers } from './../reducers';
import { saveState } from './localStorage';
import throttle from 'lodash/throttle';
import { savedState } from './savedState';

const middlewares = [thunk];

if (process.env.NODE_ENV !== `production`) {
  const createLogger = require(`redux-logger`);
  const logger = createLogger();
  middlewares.push(logger);
}

const createStoreWithMiddleware = applyMiddleware(...middlewares)(createStore);
const store = createStoreWithMiddleware(rootReducer, savedState, responsiveStoreEnhancer);

store.subscribe(throttle(() => {
  const allStates = store.getState();
  const localStorageStates = {};
  for(let state in allStates){
    if(!sessionOnlyReducers.includes(state)){
      localStorageStates[state] = allStates[state];
    }
  }

  saveState(localStorageStates);
}, 1000));

window.addEventListener('resize', () => store.dispatch(calculateResponsiveState(window)));

export default store;



// WEBPACK FOOTER //
// ./src/store/configureStore.js